import { defineMessages } from '@sm/intl';

const NAVBARCOPY = defineMessages({
  PRODUCTS: {
    id: 'NavBarCopy.products',
    defaultMessage: 'Products',
    description: '[Type: Label][Vis.: low] - Products section of nav bar'
  },
  SOLUTIONS: {
    id: 'NavBarCopy.solutions',
    defaultMessage: 'Solutions',
    description: '[Type: Label][Vis.: low] - Solutions section of nav bar'
  },
  RESOURCES: {
    id: 'NavBarCopy.resources',
    defaultMessage: 'Resources',
    description: '[Type: Label][Vis.: low] - Resources section of nav bar'
  },
  HELP_CENTER: {
    id: 'NavBarCopy.helpCenter',
    defaultMessage: 'Help Center',
    description: '[Type: Label][Vis.: low] - Help Center section of nav bar'
  },
  PLANS_AND_PRICING: {
    id: 'NavBarCopy.plansAndPricing',
    defaultMessage: 'Plans & Pricing',
    description: '[Type: Label][Vis.: low] - Plans & Pricing section of nav bar'
  },
  TEAM_SUMMARY: {
    id: 'NavBarCopy.teamSummary',
    defaultMessage: 'Team Summary',
    description: '[Type: Label][Vis.: low] - Team Summary section of nav bar'
  },
  MANAGE_USERS: {
    id: 'NavBarCopy.manageUsers',
    defaultMessage: 'Manage Users',
    description: '[Type: Label][Vis.: low] - Manage Users section of nav bar'
  },
  ADD_USERS: {
    id: 'NavBarCopy.addUsers',
    defaultMessage: 'Add Users',
    description: '[Type: Label][Vis.: low] - Add Users section of nav bar'
  },
  ADMIN_DASHBOARD: {
    id: 'NavBarCopy.adminDashboard',
    defaultMessage: 'Admin Dashboard',
    description: '[Type: Label][Vis.: low] - Admin Dashboard section of nav bar'
  },
  WORKGROUPS: {
    id: 'NavBarCopy.workgroups',
    defaultMessage: 'Workgroups',
    description: '[Type: Label][Vis.: low] - Workgroup section of nav bar'
  },
  LIBRARY: {
    id: 'NavBarCopy.library',
    defaultMessage: 'Library',
    description: '[Type: Label][Vis.: low] - Library section of nav bar'
  },
  ACTIVITY: {
    id: 'NavBarCopy.activity',
    defaultMessage: 'Activity',
    description: '[Type: Label][Vis.: low] - Activity section of nav bar'
  },
  OFFLINE_DEVICES: {
    id: 'NavBarCopy.offlineDevices',
    defaultMessage: 'Offline Devices',
    description: '[Type: Label][Vis.: low] - Offline Devices section of nav bar'
  },
  MANAGE_CREDITS: {
    id: 'NavBarCopy.manageCredits',
    defaultMessage: 'Manage Credits',
    description: '[Type: Label][Vis.: low] - Manage Credits section of nav bar'
  },
  SETTINGS: {
    id: 'NavBarCopy.settings',
    defaultMessage: 'Settings',
    description: '[Type: Label][Vis.: low] - Settings section of nav bar'
  },
  DASHBOARD: {
    id: 'NavBarCopy.dashboard',
    defaultMessage: 'Dashboard',
    description: '[Type: Label][Vis.: low] - Dashboards section of nav bar'
  },
  MY_SURVEYS: {
    id: 'NavBarCopy.mySurveys',
    defaultMessage: 'My Surveys',
    description: '[Type: Label][Vis.: low] - My surveys section of nav bar'
  },
  MY_TEAM: {
    id: 'NavBarCopy.myTeam',
    defaultMessage: 'My Team',
    description: '[Type: Label][Vis.: low] - My team section of nav bar'
  },
  DIVISIONS: {
    id: 'NavBarCopy.divisions',
    defaultMessage: 'Divisions',
    description: '[Type: Label][Vis.: low] - Settings section of nav bar'
  }
});

export default NAVBARCOPY;
